import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Route guard (beforeLoad): the calendar ships behind the `calendar` feature flag until released. */
export async function requireCalendarFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.calendar || !flags.tasks) throw notFound();
}
